module.exports = __webpack_public_path__ + "img/access-google.b942249d.png";